import styles from "./dev.module.scss";

const Dev = () => {
  return (
    <div className={styles.dev__wrap}>
      <img src="/logo.svg" alt="logo" />
      <div className={styles.dev}>
        <p className={styles.dev__title}>В разработке ⚙️</p>

        <p className={styles.dev__description}>
          Версия мини-приложения 1.2. prod
        </p>
      </div>
    </div>
  );
};
export default Dev;
